const state = {
  // Список стартов
  marathons: [],

  // Общее количество стартов
  total: 0,

  // Флаг показывающий загружается ли сейчас страница со стартами
  isLoading: false,
};

export default state;
